<template>
  <section class="cf-page-container">
    <cf-menu-page-header v-if="!isOrderingDisabled" />

    <cf-menu-list
      :is-read-only="isOrderingDisabled"
      :is-category-card-layout="isCategoryCardLayout"
      :hide-category-name="hideCategoryName"
    >
      <template #menu-list-page-banner>
        <cf-location-status-page-banner />

        <cf-page-banner
          v-if="content.MenuBanner.description"
          :is-alternate-style="true"
        >
          {{ content.MenuBanner.description }}
        </cf-page-banner>
      </template>
    </cf-menu-list>

    <!-- Router View -->
    <router-view />
  </section>
</template>


<script>
  import { mapGetters } from 'vuex';

  import events from '@/services/events';

  import CfMenuPageHeader from '@/view/components/globals/cf-menu-page-header/index.vue';
  import CfMenuList from '@/view/components/globals/cf-menu-list/index.vue';
  import CfLocationStatusPageBanner from '@/view/components/globals/cf-location-status-page-banner/index.vue';
  import CfPageBanner from '@/view/components/shared/cf-page-banner/index.vue';


  export default {
    name: 'OrderMenuPage',

    components: {
      CfMenuPageHeader,
      CfMenuList,
      CfLocationStatusPageBanner,
      CfPageBanner
    },

    metaInfo() {
      return {
        title: 'Menu'
      };
    },

    beforeRouteUpdate(to, from, next) {
      this.setMenuType(to);

      next();
    },

    computed: {
      ...mapGetters('content', ['content']),
      ...mapGetters('merchant', ['merchant']),
      ...mapGetters('menu', ['menu']),
      ...mapGetters('session', ['session']),
      ...mapGetters('orders', ['order']),

      isOrderingDisabled() {
        return this.merchant.features['disable-ordering'];
      },

      isCategoryCardLayout() {
        return this.merchant.features['menu-category'];
      },

      hideCategoryName() {
        return this.merchant.features['hide-menu-category-name'];
      },

      isEnrollInLoyaltyParam() {
        const isEnrollInLoyaltyParam = Object.prototype.hasOwnProperty.call(this.$route.query, 'enrollInLoyalty');

        return isEnrollInLoyaltyParam;
      },

      isLoyaltyPopUpDisplayed() {
        return this.merchant.options.loyaltyOptions.loyaltyPopupOnSignInEnabled;
      },

      routeQuerySsoCode() {
        return this.$route.query.code;
      }
    },

    created() {
      this.onComponentCreated();
    },

    methods: {
      onComponentCreated() {
        this.setMenuType(this.$route);

        if (this.session.route.action === 'checkout') {
          this.handleRouteAction();
        }
        else {
          if (this.isAgeVerficationRequiredForMenu) {
            this.$openModal('ageVerificationModal', { required: true });
          }

          if (this.routeQuerySsoCode) {
            this.verifySSO();
          }

          this.$store.dispatch('merchant/openInAppMessage', { type: 'Menu' });

          if (this.isLoyaltyPopUpDisplayed) {
            events.emit('loyalty-popup-card:open', { autoOpen: true });
          }

          if (this.isEnrollInLoyaltyParam) {
            events.emit('enroll-in-loyalty:open', { forceOpen: true });
          }
        }
      },

      setMenuType(route) {
        this.$store.dispatch('menu/selectMenuType', route.query.type);
      },

      async verifySSO() {
        const dispatchPayload = { authCode: this.routeQuerySsoCode };

        await this.$store.dispatch('session/verifySSO', dispatchPayload);

        this.$router.replace({ query: null });
      },

      handleRouteAction() {
        this.$closeAllModals();

        if (this.order.payments.length) {
          const [payment] = this.order.payments;

          const routePayload = {
            name: 'orderReceipt',
            params: {
              merchantId: this.$route.params.merchantId,
              receiptToken: payment.receiptToken
            }
          };

          this.$router.push(routePayload);
        }
        else {
          this.$store.dispatch('session/updateRouteParamsDirectly', { action: null });

          this.$router.push({ name: 'orderAheadCheckoutSummaryPage', params: { merchantId: this.$route.params.merchantId } });
        }
      }
    }
  };
</script>
